var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.499,
    viewBox: "0 0 16.5 16.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1,13.128a4.479,4.479,0,0,0,1.483-.163c2.007,1.709,7.309,6.223,7.714,6.643a.8.8,0,0,0,.595.266,1.323,1.323,0,0,0,.845-.381c.274-.262,1.309-1.38,1.11-1.586-.595-.611-.754-.734-1-.984-.369-.377-1.122.04-1.428-.091a.585.585,0,0,1-.412-.5,7.412,7.412,0,0,1,.119-.94.992.992,0,0,0-.365-.754.835.835,0,0,0-.619-.345c-.357-.008-.829.508-1.206.123s.246-.94.2-1.348a1.5,1.5,0,0,0-.857-.956c-.242-.052-.865.464-1.218.385a.827.827,0,0,1-.436-.452c-.04-.182.274-.992.234-1.174a2.789,2.789,0,0,0-.412-.69,4.467,4.467,0,0,0,.373-1.892A4.826,4.826,0,0,0,8.092,3.375a4.819,4.819,0,0,0-4.72,4.918A4.753,4.753,0,0,0,8.1,13.128ZM7.18,5.913A1.269,1.269,0,1,1,5.911,7.182,1.268,1.268,0,0,1,7.18,5.913Z",
    transform: "translate(-3.373 -3.375)",
    fill: "#fd6b4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOrange);
export default __webpack_public_path__ + "static/media/key_orange.d7175d2f9c75fcfe1eadd42fd0fd4d97.svg";
export { ForwardRef as ReactComponent };